export default __webpack_public_path__ + "static/media/Rev.ec60a221.jfif";